import React from 'react';

import InstallmentContent from '../../common/InstallmentContent';

export default ({
  styles,
  picture,
  onSubmit,
  currency,
  balance,
  firstName,
  lastName,
  email,
  mobilePhone,
  phone,
}) => {
  return (
    <div className={styles['recommend-help-calculator__wrapper']}>
      <div className={styles['recommend-help-calculator__calculator']}>
        <img
          className={styles['recommend-help-calculator__pic']}
          src={picture}
          alt="calculator-pic"
        />
        <InstallmentContent
          {...{
            onSubmit,
            currency,
            balance,
            firstName,
            lastName,
            email,
            mobilePhone,
            phone,
          }}
          pageName="recommend-help"
          className={styles['recommend-help-calculator__form-wrapper']}
        />
      </div>
    </div>
  );
};
